angular.module("manager").factory("DeviceService", ["$http", "ENV", function ($http, ENV) {

	/**
	 * API
	 */
	var api = {
		RESOURCE_URI: "/devices/",
		addDevice: addDevice,
		deleteDeviceById: deleteDeviceById,
		editDevice: editDevice,
		editDeviceForClient: editDeviceForClient,
		editDeviceActiveStatus: editDeviceActiveStatus,
		getDeviceById: getDeviceById,
		getAllDevicesByClient: getAllDevicesByClient,
		getLogsDevice: getLogsDevice
	};


	/**
	 * Récupérer toutes les devices pour une compagnie.
	 * @param deviceId Identifiant de compagnie dont on souhaite récupérer les devices.
	 * @returns {HttpPromise}
	 */
	function getAllDevicesByClient() {
		return $http.get(ENV.API_URL + api.RESOURCE_URI);
	}

	/**
	 * Récupérer toutes les logs d'un appareil
	 * @returns {HttpPromise}
	 */
	function getLogsDevice(clientId, deviceId) {
		return $http.get(ENV.API_URL + "/device-logs/device/" + deviceId + "/client/" + clientId + "?limit=25");
	}

	/**
	 * Mettre à jour un device.
	 * @param device à metre à jour
	 * @returns {*|HttpPromise}
	 */
	function editDevice(deviceId, device) {
		return $http.put(ENV.API_URL + api.RESOURCE_URI + deviceId, device);
	}

	/**
	 * Mettre à jour un device.
	 * @param device à metre à jour
	 * @returns {*|HttpPromise}
	 */
	function editDeviceForClient(deviceId, device, clientId) {
		return $http.put(ENV.API_URL + api.RESOURCE_URI + deviceId + "/client/" + clientId, device);
	}

	/**
	 * Mettre à jour un statu de device
	 * @param deviceId à metre à jour
	 * @param status le nouveau statut
	 * @returns {*|HttpPromise}
	 */
	function editDeviceActiveStatus(deviceId, status) {
		return $http.put(ENV.API_URL + api.RESOURCE_URI + deviceId + "/activation", $.param({active: status}), {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
	}


	/**
	 * Récupérer un devices par son ID.
	 *
	 * @param id l'Id du device à récupérer.
	 * @returns {*}
	 */
	function getDeviceById(deviceId) {
		return $http.get(ENV.API_URL + api.RESOURCE_URI + deviceId);
	}

	/**
	 * Supprimer un device.
	 *
	 * @param device l'ID du device à supprimer.
	 * @returns {HttpPromise|*|{display}}
	 */
	function deleteDeviceById(deviceId) {
		return $http.delete(ENV.API_URL + api.RESOURCE_URI + deviceId);
	}

	/**
	 * POster un company vers le serveur.
	 * @param companyId L'ID de compagnie à laquelle associer le device.
	 * @param device le device à ajouter.
	 * @returns {*|HttpPromise}
	 */
	function addDevice(device) {
		return $http.post(ENV.API_URL + api.RESOURCE_URI, device);
	}

	return api;

}]);
